import { useNavigate } from "react-router-dom";
import { useMobileMenu } from "./useMobileMenu";

export function useHandleNavigationClick() {
  const { closeMobileMenu } = useMobileMenu();

  const navigate = useNavigate();

  const handleNavigationClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    to: string
  ) => {
    e.preventDefault();

    closeMobileMenu();

    navigate(to);
  };

  const handleNavigationAnchorClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    targetId: string
  ) => {
    e.preventDefault();

    closeMobileMenu();

    const element = document.getElementById(targetId);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return { handleNavigationClick, handleNavigationAnchorClick };
}

export default useHandleNavigationClick;
